import Nullstack from 'nullstack';
export default function IconPassword({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-password",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 10v4"
  }), "   ", Nullstack.element("path", {
    d: "M10 13l4 -2"
  }), "   ", Nullstack.element("path", {
    d: "M10 11l4 2"
  }), "   ", Nullstack.element("path", {
    d: "M5 10v4"
  }), "   ", Nullstack.element("path", {
    d: "M3 13l4 -2"
  }), "   ", Nullstack.element("path", {
    d: "M3 11l4 2"
  }), "   ", Nullstack.element("path", {
    d: "M19 10v4"
  }), "   ", Nullstack.element("path", {
    d: "M17 13l4 -2"
  }), "   ", Nullstack.element("path", {
    d: "M17 11l4 2"
  }), " ");
}